// Minimal jQuery plugin matching Bootstrap 3's $.fn.collapse API.
// Drop-in replacement that preserves class transitions and events
// consumed by Editor info panels, contenteditable, and frame expand.
/* global jQuery */
(function ($) {
    const TRANSITION_DURATION = 350;

    class Collapse {
        constructor(element) {
            this.element = element;
            this.$element = $(element);
        }

        show() {
            if (this.$element.hasClass('in') || this.$element.hasClass('collapsing')) return;
            this.$element.trigger('show.bs.collapse');
            this.$element.removeClass('collapse').addClass('collapsing');
            this.element.style.height = '0';
            requestAnimationFrame(() => {
                this.element.style.height = `${this.element.scrollHeight}px`;
                setTimeout(() => {
                    this.$element.removeClass('collapsing').addClass('collapse in');
                    this.element.style.height = '';
                    this.$element.trigger('shown.bs.collapse');
                }, TRANSITION_DURATION);
            });
        }

        hide() {
            if (!this.$element.hasClass('in')) return;
            this.$element.trigger('hide.bs.collapse');
            this.element.style.height = `${this.element.scrollHeight}px`;
            // oxlint-disable-next-line no-void
            void this.element.offsetHeight; // reflow
            this.$element.removeClass('collapse in').addClass('collapsing');
            this.element.style.height = '0';
            setTimeout(() => {
                this.$element.removeClass('collapsing').addClass('collapse');
                this.element.style.height = '';
                this.$element.trigger('hidden.bs.collapse');
            }, TRANSITION_DURATION);
        }

        toggle() {
            if (this.$element.hasClass('in')) {
                this.hide();
            } else {
                this.show();
            }
        }
    }

    $.fn.collapse = function (option) {
        return this.each(function () {
            if (option === 'show') new Collapse(this).show();
            else if (option === 'hide') new Collapse(this).hide();
            else new Collapse(this).toggle();
        });
    };

    // Delegated click handler for data-toggle="collapse"
    $(document).on('click', '[data-toggle="collapse"]', e => {
        e.preventDefault();
        const target = $(e.currentTarget).data('target') || $(e.currentTarget).attr('href');
        $(target).collapse('toggle');
    });
})(jQuery);
